import React from "react";
import clsx from "clsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Expansion from "components/Expansion";
import setThanksMailHourMutation from "relay/event/mutations/setThanksMailHour";

const styles = () => ({
  root: {
    marginTop: 10,
  },
  setBox: {
    marginTop: 20,
    width: 125,
    display: "grid",
    gridTemplateColumns: "30px 64px 30px",
    height: 32,
    borderTop: "1px solid #EEE",
    borderLeft: "1px solid #EEE",
  },
  gridItem: {
    borderBottom: "1px solid #EEE",
    borderRight: "1px solid #EEE",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSsize: 16,
    lineHeight: "32px",
    color: "#333",
  },
  actionBox: {
    cursor: "pointer",
    fontSize: 16,
    userSelect: "none",
  },
});

export default withStyles(styles)(function index({
  id,
  expanded,
  handleExpandedPanel,
  showNotification,
  classes,
  ...rest
}) {
  const [hours, setHours] = React.useState(0);

  React.useEffect(() => {
    if (rest.thankYouEmailHour) setHours(rest.thankYouEmailHour);
  }, []);

  const setThanksMailHours = async (hour) => {
    let res = await setThanksMailHourMutation({ id, hour });
    if (res.setThankYouEmailHour) {
      showNotification(`Time has been updated successfully.`, "success");
    }
  };

  return (
    <div className={classes.root}>
      <Expansion
        expanded={expanded === "Fifth"}
        name="Fifth"
        handleExpandedPanel={handleExpandedPanel}
        header="Send Thank You Email"
        subtitle="Set a buffer time for the Thank You email before it goes to the attendees. The buffer time starts as soon as the event time ends."
      >
        <div className={classes.setBox}>
          <div
            className={clsx(classes.gridItem, classes.actionBox)}
            onClick={() => {
              if (hours > 1) {
                setHours(hours - 1);
                setThanksMailHours(hours - 1);
              }
            }}
          >
            -
          </div>
          <div className={classes.gridItem}>
            {hours} hr{hours > 1 ? "s" : ""}
          </div>
          <div
            className={clsx(classes.gridItem, classes.actionBox)}
            onClick={() => {
              setHours(hours + 1);
              setThanksMailHours(hours + 1);
            }}
          >
            +
          </div>
        </div>
      </Expansion>
    </div>
  );
});
